import AuthService from '@/services/AuthService'

const getters = {
  getToken: state => state.token,
  getIsAuthorize: state => state.isAuthorize,
  getAuthUser: state => state.authUser,
  getPlayer: state => state.player,
  slug: state => {
    console.log('GETTING SLUG')
    let slug = state.authUser ? state.authUser.organization[0].slug : ''
    return slug
  }
}

const actions = {
  async signin ({commit, dispatch}, payload) {
    const getTokenPromise = AuthService.login(payload)
    const response = await Promise.resolve(getTokenPromise)

    commit('LOGIN_SUCCESS', response)

    dispatch('setUser').then(
      () => {
        if (payload.callback) {
          payload.callback()
        }
      }
    )
  },
  signout ({commit}) {
    commit('LOGOUT')
  },
  setUser ({commit}) {
    return new Promise((resolve, reject) => {
      if (AuthService.getToken()) {
        AuthService.getAuthUser().then(
          (response) => {
            commit('SET_AUTH_USER', response)
            resolve(response)
          }
        )
      }
    })
  },
  setPlayer ({commit}, player) {
    commit('SET_PLAYER', player)
  }
}

const state = {
  isAuthorize: localStorage.getItem('isAuthorize') || false,
  token: localStorage.getItem('token') || '',
  authUser: '',
  player: ''
}

const mutations = {
  LOGIN_SUCCESS (state, data) {
    state.token = data.token
    state.isAuthorize = true
    AuthService.setToken(data.token)
    localStorage.setItem('isAuthorize', true)
  },
  LOGOUT (state) {
    state.token = ''
    state.isAuthorize = false
    state.authUser = ''
    state.player = ''
    AuthService.clearToken()
    localStorage.removeItem('isAuthorize')
  },
  SET_AUTH_USER (state, user) {
    state.authUser = user
    console.log('GETTING user')
  },
  SET_PLAYER (state, player) {
    state.player = player
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/auth.js